var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('Navbar',{attrs:{"tel":"3003 0256"}}),_c('div',{staticClass:"header-content"},[_c('Logo',{attrs:{"width":"176","height":"40"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }